export enum RoleSettingsTab {
  Vendor = 'vendor',
  Customer = 'customer',
}
